
/* ============================================================================
FILE: po-katupirsia5-yuyarina-texts-fr-en-es-20260313.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5YuyarinaTextsFR_EN_ES_20260313
ROOT: .po-k5-section[data-po-k5]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_YUYARINA_TEXTS_20260313__) return;
  window.__PO_K5_YUYARINA_TEXTS_20260313__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="yuyarina"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);

    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)) {
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)) {
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Posœnnoïal",
      "Système posœnnoïal",
      "Organon posœnnoïal",
      "Posœnnoïamie",
      "Posœnnomia",
      "Katûpirsia",
      "Katûvýs",
      "Katûsýs",
      "Katûvýsqun",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone régulateur",
      "Sceau d’Équiphase",
      "Sceau de Syntonie",
      "Sceau d’Aísthisi",
      "Sceau d’Anépôron",
      "Sceau d’Ifẹ̀",
      "Sceau d’Ayeẹmí",
      "Sceau d’Ọ̀rọ̀yuyay",
      "Sceau de Yuyarina",
      "Sceau Yuyarina",
      "Sceau d’Œndomare",
      "Ēkuphasa",
      "Syntōnēa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Yuyarina",
      "Œndomarê",
      "Taxiêlîs",
      "Tiqqunbahu",
      "Takimarah",
      "Ušôprogalenmestûd",
      "Pistis Chraomai",
      "RéZonans",
      "RéZonanser",
      "RéZoindre",
      "Aliœvolution",
      "Péroptissimisme",
      "Illusion",
      "Addition synchrêtique",
      "Instantané multiple",
      "Superposition de perspectives",
      "Sujet pluriel",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Stratification d’expériences",
      "Expérience fragmentée",
      "Conscientisation introspective",
      "Conscientisation dynamique",
      "Conscience vibratoire",
      "Lucidité critique",
      "Lucidité structurante",
      "Adaptabilité critique",
      "Adaptabilité ouverte",
      "Approche fluide et adaptative",
      "Déterminisme du choix",
      "Myrte décisif",
      "Néotaxie",
      "Identité évolutive",
      "Exploration de l’inconnu",
      "Miroirs posœnnoïaux",
      "Fréquence 492",
      "Fréquence-guide",
      "Nombre-guide",
      "Humanus",
      "MOCoN",
      "Àpákan"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    if (!parts.length) return null;

    try {
      return new RegExp("(" + parts.join("|") + ")", "g");
    } catch (e) {
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  var CANONICAL_OVERRIDES = [
    [/\bGuide-number\b/gi, "Nombre-guide"],
    [/\bGuide number\b/gi, "Nombre-guide"],
    [/\bN[uú]mero-gu[ií]a\b/gi, "Nombre-guide"],
    [/\bGuide-frequency\b/gi, "Fréquence-guide"],
    [/\bGuide frequency\b/gi, "Fréquence-guide"],
    [/\bFrecuencia-gu[ií]a\b/gi, "Fréquence-guide"],
    [/\bFrequency 286\b/gi, "Fréquence d’alignement 286"],
    [/\bFrecuencia 286\b/gi, "Fréquence d’alignement 286"],
    [/\bReactivation of meaning\b/gi, "Réactivation du sens"],
    [/\bReactivaci[oó]n del sentido\b/gi, "Réactivation du sens"],
    [/\bIsqunian emanation\b/gi, "Émanation isqunienne"],
    [/\bEmanaci[oó]n isquniana\b/gi, "Émanation isqunienne"],
    [/\bThrenisqun entity\b/gi, "Entité de Threnisqun"],
    [/\bEntidad del Threnisqun\b/gi, "Entité de Threnisqun"],
    [/\bSeal of Yuyarina\b/gi, "Sceau de Yuyarina"],
    [/\bSello de Yuyarina\b/gi, "Sceau de Yuyarina"],
    [/\bDynamic awareness\b/gi, "Conscientisation dynamique"],
    [/\bConcientizaci[oó]n din[aá]mica\b/gi, "Conscientisation dynamique"]
  ];

  function enforceCanonicalFrench(src) {
    var out = clampStr(src);
    if (!out) return "";
    for (var i = 0; i < CANONICAL_OVERRIDES.length; i++) {
      out = out.replace(CANONICAL_OVERRIDES[i][0], CANONICAL_OVERRIDES[i][1]);
    }
    return out;
  }

  function protectLexiconInHTML(html) {
    var src = enforceCanonicalFrench(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect notranslate">' + m + "</span>";
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(escapeHTML(enforceCanonicalFrench(txt)));
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = enforceCanonicalFrench(data && data.alt ? data.alt : "");
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      try { el.style.display = ""; } catch (e) {}
    } else {
      el.setAttribute("hidden", "");
      try { el.style.display = "none"; } catch (e) {}
    }
  }

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    activeKey: "",
    activeButtons: []
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function getAudioUILabels(lang) {
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    for (var i = 0; i < PO_AUDIO_STATE.activeButtons.length; i++) {
      try { PO_AUDIO_STATE.activeButtons[i].setAttribute("data-po-audio-state", "idle"); } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButtons = [];
  }

  function setAudioButtonsState(root, lang, activeKey) {
    var labels = getAudioUILabels(lang);
    var all = root.querySelectorAll(".po-audio-btn");
    PO_AUDIO_STATE.activeButtons = [];
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind") || "block";
      var key = btn.getAttribute("data-po-audio-key") || "";
      var active = activeKey && key === activeKey;
      btn.setAttribute("data-po-audio-state", active ? "playing" : "idle");
      btn.textContent = active ? labels.stop : (kind === "general" ? labels.general : labels.block);
      if (active) PO_AUDIO_STATE.activeButtons.push(btn);
    }
  }

  function audioTextFromNode(node) {
    if (!node) return "";
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll(".po-audio-btn, script, style");
    for (var i = 0; i < junk.length; i++) {
      if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    var txt = "";
    try { txt = clone.innerText || clone.textContent || ""; } catch (e) { txt = clone.textContent || ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([,;:.!?])/g, "$1").trim();
  }

  function splitTextForSpeech(text) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?]+[.!?…]?/g) || [src];
    var maxLen = 210;
    var out = [];
    var cur = "";
    for (var i = 0; i < parts.length; i++) {
      var piece = clampStr(parts[i]).trim();
      if (!piece) continue;
      if (!cur) {
        cur = piece;
        continue;
      }
      if ((cur + " " + piece).length <= maxLen) {
        cur += " " + piece;
      } else {
        out.push(cur);
        cur = piece;
      }
    }
    if (cur) out.push(cur);
    return out;
  }

  function ensureDetailsOpen(details) {
    if (!details) return;
    try { details.open = true; } catch (e) {}
  }

  function getRootGeneralText(root) {
    var keys = ["title", "kicker", "h_def", "def_short", "def_long"];
    var chunks = [];
    for (var i = 0; i < keys.length; i++) {
      var el = root.querySelector('[data-po-slot="' + keys[i] + '"]');
      var txt = audioTextFromNode(el);
      if (txt) chunks.push(txt);
    }
    return chunks.join(" ");
  }

  function getBlockText(details) {
    if (!details) return "";
    var summary = details.querySelector(".po-lex-summary");
    var bodyParts = [];
    var title = audioTextFromNode(summary);
    if (title) bodyParts.push(title);
    var children = details.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === "summary") continue;
      var txt = audioTextFromNode(children[i]);
      if (txt) bodyParts.push(txt);
    }
    return bodyParts.join(" ");
  }

  function buildAudioUnits(root, startIndex) {
    var units = [];
    if (startIndex === 0) {
      var general = getRootGeneralText(root);
      if (general) units.push({ key: "general", kind: "general", text: general });
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++) {
      var txt = getBlockText(details[i]);
      if (!txt) continue;
      units.push({ key: "block-" + i, kind: "block", text: txt, details: details[i] });
    }
    return units;
  }

  function speakChunks(lang, chunks, onDone) {
    if (!PO_AUDIO_SYNTH || !chunks.length) {
      if (typeof onDone === "function") onDone();
      return;
    }

    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    var langTag = (normLang(lang) || "fr");
    var preferred = { fr: "fr-FR", en: "en-US", es: "es-ES" }[langTag] || "fr-FR";
    var voice = null;
    for (var i = 0; i < voices.length; i++) {
      var vl = (voices[i].lang || "").toLowerCase();
      if (vl.indexOf(langTag) === 0) { voice = voices[i]; break; }
    }

    function next(idx) {
      if (idx >= chunks.length) {
        if (typeof onDone === "function") onDone();
        return;
      }
      var utter = new SpeechSynthesisUtterance(chunks[idx]);
      utter.lang = preferred;
      if (voice) utter.voice = voice;
      utter.rate = 0.98;
      utter.pitch = 1;
      utter.onend = function () { next(idx + 1); };
      utter.onerror = function () { next(idx + 1); };
      try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { next(idx + 1); }
    }

    next(0);
  }

  function playAudioUnits(root, lang, units, activeKey) {
    if (!units || !units.length) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice();
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.activeKey = activeKey || units[0].key;
    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);

    function advance() {
      if (!PO_AUDIO_STATE.units.length || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      setAudioButtonsState(root, lang, unit.key);
      if (unit.details) ensureDetailsOpen(unit.details);
      var chunks = splitTextForSpeech(unit.text);
      speakChunks(lang, chunks, function () {
        PO_AUDIO_STATE.unitPos += 1;
        advance();
      });
    }

    advance();
  }

  function makeAudioButton(kind, key, lang) {
    var labels = getAudioUILabels(lang);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    btn.setAttribute("data-po-audio-state", "idle");
    btn.textContent = kind === "general" ? labels.general : labels.block;
    return btn;
  }

  function injectAudioButtons(root, lang) {
    if (!root) return;

    var old = root.querySelectorAll(".po-audio-btn");
    for (var i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }

    var generalBtn = makeAudioButton("general", "general", lang);
    var meta = root.querySelector(".po-axis-meta");
    var defShort = root.querySelector('[data-po-slot="def_short"]');
    var firstDetails = root.querySelector(".po-lex-details");

    if (meta && meta.parentNode) {
      meta.parentNode.insertBefore(generalBtn, meta.nextSibling);
    } else if (defShort && defShort.parentNode) {
      defShort.parentNode.insertBefore(generalBtn, defShort);
    } else if (firstDetails && firstDetails.parentNode) {
      firstDetails.parentNode.insertBefore(generalBtn, firstDetails);
    }

    generalBtn.addEventListener("click", function () {
      if (PO_AUDIO_STATE.activeKey === "general") {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      playAudioUnits(root, lang, buildAudioUnits(root, 0), "general");
    });

    var details = root.querySelectorAll(".po-lex-details");
    for (var j = 0; j < details.length; j++) {
      var summary = details[j].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = makeAudioButton("block", "block-" + j, lang);
      btn.addEventListener("click", (function (idx) {
        return function (ev) {
          try { ev.preventDefault(); ev.stopPropagation(); } catch (e) {}
          var key = "block-" + idx;
          if (PO_AUDIO_STATE.activeKey === key) {
            stopAudio();
            setAudioButtonsState(root, lang, "");
            return;
          }
          playAudioUnits(root, lang, buildAudioUnits(root, idx), key);
        };
      })(j));
      summary.appendChild(btn);
    }

    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);
  }

  function initAudioEverywhere(lang) {
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      injectAudioButtons(roots[i], lang || getLang());
    }
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  var CONTENT = {
    fr: {
      title: "Yuyarīnâ",
      kicker: "Entité isqunienne du Sceau de Yuyarina — recomposition des formes érodées et réactivation du sens dans les pratiques linéaires.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Yuyarina_copie.png?v=1772924553", alt: "Idéogramme de Yuyarīnâ" },

      h_def: "Définition canonique",

      chip_1: "Sceau associé : Sceau de Yuyarina",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_Yuyarina_286_2.png?v=1772905412", alt: "Sceau de Yuyarina" },
      chip_2: "Fréquence d’alignement 286",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_286.png?v=1773449437", alt: "Nombre-guide 286" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Yuyarīnâ</strong> recompose les formes érodées, réintroduit mémoire active et direction juste, afin que l’acte retrouve tenue, plasticité et axe vivant.",

      def_long:
        "<p>Dans le corpus, <strong>Yuyarīnâ</strong> veille sur la permanence du sens dans les pratiques humaines répétitives, linéaires ou mécaniques. Elle intervient lorsque le geste continue mais que sa charge interne s’est effilochée.</p>" +
        "<p>Elle réinsuffle du souffle mémoriel, du lien symbolique et une vibration transmutative dans l’acte répétitif, sans restaurer à l’identique : elle remet en marche par variation juste.</p>",

      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Entité de recomposition des formes érodées",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "286",
      grid_scope_label: "Axes et déploiement",
      grid_scope_value:
        "<ul>" +
        "<li>Champ : fatigue de sens, répétition mécanique, érosion symbolique</li>" +
        "<li>Mode : mémoire active, variation, reprise d’axe</li>" +
        "<li>Fonction : réactivation du sens dans les pratiques linéaires</li>" +
        "</ul>",

      h_intro: "Quand la forme continue mais que le sens s’érode",
      p_intro:
        "<p><strong>Yuyarīnâ</strong> agit dans les zones où l’automatisme a pris la place de la présence : gestes quotidiens, rituels routinisés, pratiques créatives fatiguées, transmissions devenues mécaniques.</p>" +
        "<p>Sa logique n’est pas celle d’un retour nostalgique. Elle rappelle l’origine active, introduit une variation unique, puis remet la forme en direction dans la mémoire en marche.</p>",

      h_actions: "Fonctions rituelles",
      actions:
        "<ol>" +
        "<li>Raviver le sens dans les gestes automatisés ou les rituels devenus mécaniques.</li>" +
        "<li>Réconcilier mémoire vive et pratique quotidienne.</li>" +
        "<li>Réactiver les symboliques oubliées d’un acte, d’un mot ou d’un objet.</li>" +
        "<li>Permettre la mutation d’un cycle figé en séquence transmutative.</li>" +
        "<li>Éveiller la présence dans les séquences routinières, collectives ou individuelles.</li>" +
        "</ol>",

      h_phrase: "Phrase opérative",
      phrase:
        "<p>« Yuyarīnâ : je rappelle l’origine, j’introduis une variation unique, et la forme reprend sa direction dans la mémoire en marche. »</p>",

      h_table: "Tableau d’usage",
      table_head_1: "Situation",
      table_head_2: "Signe",
      table_head_3: "Action de Yuyarīnâ",
      table_rows:
        "<tr><td>Pratique devenue mécanique</td><td>Le geste continue sans adhérence intérieure</td><td>Réintroduit mémoire active et direction juste</td></tr>" +
        "<tr><td>Fatigue poïétique</td><td>L’atelier produit mais l’axe se brouille</td><td>Relance la présence par variation juste</td></tr>" +
        "<tr><td>Perte de charge symbolique</td><td>Objet, mot ou rituel affaibli par répétition</td><td>Réveille la source signifiante de l’acte</td></tr>" +
        "<tr><td>Transmission usée</td><td>Forme pédagogique ou collective figée</td><td>Réactive tenue, plasticité et mémoire vive</td></tr>",

      h_entite: "Sceau de Yuyarina",
      entite_kicker: "Source isqunienne de Yuyarīnâ",
      entite_body:
        "<p>Le <strong>Sceau de Yuyarina</strong> porte la fonction régulatrice de recomposition des formes issues de l’érosion du sens. <strong>Yuyarīnâ</strong> en est la densité opérative activable dans <strong>Threnisqun</strong>.</p>" +
        "<p>Là où le Sceau repère l’usure symbolique et oriente la régulation, l’entité rend ce geste présent, situé et praticable dans les gestes humains.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Rappel de souffle dans l’acte oublié",
      ritual_steps:
        "<ol>" +
        "<li>Choisir un geste quotidien : écrire, marcher ou boire.</li>" +
        "<li>Le répéter en ralentissant le mouvement, en silence.</li>" +
        "<li>À chaque mouvement, prononcer mentalement : Yuyarīnâ.</li>" +
        "<li>Fermer les yeux et visualiser le souvenir le plus ancien lié à ce geste.</li>" +
        "<li>Effectuer ensuite le même geste avec une intention renouvelée.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Quand une pratique devient automatique</li>" +
        "<li>Quand l’œuvre s’affaiblit par répétition</li>" +
        "<li>Après une période de fatigue poïétique ou de perte d’axe</li>" +
        "<li>Dans des pratiques pédagogiques, thérapeutiques ou créatives à réinvestir</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Katûpirsia</strong> — réintensifie chaque <strong>Àpákan</strong> comme fragment vivant de mémoire vibrante</li>" +
        "<li><strong>Takimarah</strong> — réoriente les modalités vers une activation consciente dans la durée</li>" +
        "<li><strong>Tiqqunbahu</strong> — fragmente les cycles linéaires pour en dégager les motifs oubliés</li>" +
        "<li><strong>Conscientisation dynamique</strong> — redonne énergie à l’acte dans son lien au sens incarné</li>" +
        "<li><strong>Posœnnomia</strong> — relance des pratiques collectives et créatives usées</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Yuyarīnâ",
      kicker: "Entité isqunienne du Sceau de Yuyarina — recomposition of eroded forms and Réactivation du sens within linear practices.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Yuyarina_copie.png?v=1772924553", alt: "Idéogramme de Yuyarīnâ" },

      h_def: "Canonical definition",

      chip_1: "Sceau associé : Sceau de Yuyarina",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_Yuyarina_286_2.png?v=1772905412", alt: "Sceau de Yuyarina" },
      chip_2: "Fréquence d’alignement 286",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_286.png?v=1773449437", alt: "Nombre-guide 286" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Yuyarīnâ</strong> recomposes eroded forms, reintroduces active memory and right direction, so that the act may recover holding, plasticity, and a living axis.",

      def_long:
        "<p>Within the corpus, <strong>Yuyarīnâ</strong> watches over the permanence of meaning in repetitive, linear, or mechanical human practices. It intervenes when the gesture continues but its inner charge has frayed.</p>" +
        "<p>It reinfuses memorial breath, symbolic linkage, and transmutative vibration into repetitive action, without restoring by simple return to the same: it sets things back in motion through a just variation.</p>",

      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "Entity of recomposition of eroded forms",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "286",
      grid_scope_label: "Axes and deployment",
      grid_scope_value:
        "<ul>" +
        "<li>Field: fatigue of meaning, mechanical repetition, symbolic erosion</li>" +
        "<li>Mode: active memory, variation, resumption of axis</li>" +
        "<li>Function: Réactivation du sens within linear practices</li>" +
        "</ul>",

      h_intro: "When form continues but meaning erodes",
      p_intro:
        "<p><strong>Yuyarīnâ</strong> acts in zones where automatism has replaced presence: daily gestures, routinized rituals, fatigued creative practices, and forms of transmission that have become mechanical.</p>" +
        "<p>Its logic is not nostalgic return. It recalls the active origin, introduces a unique variation, then restores direction within memory in motion.</p>",

      h_actions: "Ritual functions",
      actions:
        "<ol>" +
        "<li>Revive meaning within automated gestures or rituals that have become mechanical.</li>" +
        "<li>Reconcile living memory and daily practice.</li>" +
        "<li>Reactivate forgotten symbolics of an act, a word, or an object.</li>" +
        "<li>Allow the mutation of a fixed cycle into a transmutative sequence.</li>" +
        "<li>Awaken presence inside routinized, collective, or individual sequences.</li>" +
        "</ol>",

      h_phrase: "Operative phrase",
      phrase:
        "<p>“Yuyarīnâ: I recall the origin, I introduce a unique variation, and the form regains its direction within memory in motion.”</p>",

      h_table: "Usage table",
      table_head_1: "Situation",
      table_head_2: "Sign",
      table_head_3: "Action of Yuyarīnâ",
      table_rows:
        "<tr><td>Practice has become mechanical</td><td>The gesture continues without inward adhesion</td><td>Reintroduces active memory and right direction</td></tr>" +
        "<tr><td>Poietic fatigue</td><td>The studio keeps producing but the axis blurs</td><td>Relaunches presence through a just variation</td></tr>" +
        "<tr><td>Loss of symbolic charge</td><td>Object, word, or ritual weakened by repetition</td><td>Reawakens the source of meaning in the act</td></tr>" +
        "<tr><td>Worn transmission</td><td>Pedagogical or collective form has stiffened</td><td>Reactivates holding, plasticity, and living memory</td></tr>",

      h_entite: "Sceau de Yuyarina",
      entite_kicker: "Source isqunienne de Yuyarīnâ",
      entite_body:
        "<p>The <strong>Sceau de Yuyarina</strong> carries the regulating function of recomposing forms born from the erosion of meaning. <strong>Yuyarīnâ</strong> is its activable operative density within <strong>Threnisqun</strong>.</p>" +
        "<p>Where the Sceau identifies symbolic wear and orients regulation, the entity makes this gesture present, situated, and practicable within human acts.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Nom",
      ritual_name_value: "Rappel de souffle dans l’acte oublié",
      ritual_steps:
        "<ol>" +
        "<li>Choose a daily gesture: writing, walking, or drinking.</li>" +
        "<li>Repeat it while slowing the movement, in silence.</li>" +
        "<li>At each movement, pronounce inwardly: Yuyarīnâ.</li>" +
        "<li>Close the eyes and visualize the oldest memory linked to this gesture.</li>" +
        "<li>Then perform the same gesture with a renewed intention.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>When a practice becomes automatic</li>" +
        "<li>When the work weakens through repetition</li>" +
        "<li>After a period of poietic fatigue or loss of axis</li>" +
        "<li>In pedagogical, therapeutic, or creative practices that need reinvestment</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Katûpirsia</strong> — reintensifies each <strong>Àpákan</strong> as living memory</li>" +
        "<li><strong>Takimarah</strong> — reorients modalities toward conscious activation through duration</li>" +
        "<li><strong>Tiqqunbahu</strong> — fragments linear cycles to reveal forgotten motifs</li>" +
        "<li><strong>Conscientisation dynamique</strong> — restores energy to the act through embodied meaning</li>" +
        "<li><strong>Posœnnomia</strong> — relaunch of worn collective and creative practices</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    es: {
      title: "Yuyarīnâ",
      kicker: "Entité isqunienne du Sceau de Yuyarina — recomposición de formas erosionadas y Réactivation du sens en las prácticas lineales.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Yuyarina_copie.png?v=1772924553", alt: "Idéogramme de Yuyarīnâ" },

      h_def: "Definición canónica",

      chip_1: "Sceau associé : Sceau de Yuyarina",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_Yuyarina_286_2.png?v=1772905412", alt: "Sceau de Yuyarina" },
      chip_2: "Fréquence d’alignement 286",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_286.png?v=1773449437", alt: "Nombre-guide 286" },
      chip_3: "Entité de Threnisqun",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Entité de Threnisqun" },

      def_short:
        "<strong>Yuyarīnâ</strong> recompone las formas erosionadas, reintroduce memoria activa y dirección justa, para que el acto recupere sostén, plasticidad y eje vivo.",

      def_long:
        "<p>En el corpus, <strong>Yuyarīnâ</strong> vela por la permanencia del sentido en las prácticas humanas repetitivas, lineales o mecánicas. Interviene cuando el gesto continúa pero su carga interna se ha deshilachado.</p>" +
        "<p>Reinyecta aliento memorial, vínculo simbólico y vibración transmutativa en el acto repetitivo, sin restaurar por simple regreso a lo mismo: vuelve a poner en marcha mediante una variación justa.</p>",

      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Entidad de recomposición de formas erosionadas",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "286",
      grid_scope_label: "Ejes y despliegue",
      grid_scope_value:
        "<ul>" +
        "<li>Campo: fatiga de sentido, repetición mecánica, erosión simbólica</li>" +
        "<li>Modo: memoria activa, variación, recuperación del eje</li>" +
        "<li>Función: Réactivation du sens en las prácticas lineales</li>" +
        "</ul>",

      h_intro: "Cuando la forma continúa pero el sentido se erosiona",
      p_intro:
        "<p><strong>Yuyarīnâ</strong> actúa en las zonas donde el automatismo ha reemplazado la presencia: gestos cotidianos, rituales rutinarios, prácticas creativas fatigadas y transmisiones que se han vuelto mecánicas.</p>" +
        "<p>Su lógica no es un regreso nostálgico. Recuerda el origen activo, introduce una variación única y devuelve la forma a su dirección en la memoria en marcha.</p>",

      h_actions: "Funciones rituales",
      actions:
        "<ol>" +
        "<li>Reavivar el sentido en los gestos automatizados o en los rituales vueltos mecánicos.</li>" +
        "<li>Reconciliar memoria viva y práctica cotidiana.</li>" +
        "<li>Reactivar las simbólicas olvidadas de un acto, de una palabra o de un objeto.</li>" +
        "<li>Permitir la mutación de un ciclo fijado en secuencia transmutativa.</li>" +
        "<li>Despertar la presencia en secuencias rutinarias, colectivas o individuales.</li>" +
        "</ol>",

      h_phrase: "Frase operativa",
      phrase:
        "<p>« Yuyarīnâ: recuerdo el origen, introduzco una variación única, y la forma retoma su dirección en la memoria en marcha. »</p>",

      h_table: "Tabla de uso",
      table_head_1: "Situación",
      table_head_2: "Signo",
      table_head_3: "Acción de Yuyarīnâ",
      table_rows:
        "<tr><td>Práctica vuelta mecánica</td><td>El gesto sigue sin adhesión interior</td><td>Reintroduce memoria activa y dirección justa</td></tr>" +
        "<tr><td>Fatiga poiética</td><td>El taller produce pero el eje se difumina</td><td>Relanza la presencia mediante una variación justa</td></tr>" +
        "<tr><td>Pérdida de carga simbólica</td><td>Objeto, palabra o ritual debilitado por repetición</td><td>Despierta la fuente significante del acto</td></tr>" +
        "<tr><td>Transmisión desgastada</td><td>Forma pedagógica o colectiva rígida</td><td>Reactiva sostén, plasticidad y memoria viva</td></tr>",

      h_entite: "Sceau de Yuyarina",
      entite_kicker: "Source isqunienne de Yuyarīnâ",
      entite_body:
        "<p>El <strong>Sceau de Yuyarina</strong> porta la función reguladora de recomposición de las formas nacidas de la erosión del sentido. <strong>Yuyarīnâ</strong> es su densidad operativa activable dentro de <strong>Threnisqun</strong>.</p>" +
        "<p>Allí donde el Sceau identifica el desgaste simbólico y orienta la regulación, la entidad vuelve ese gesto presente, situado y practicable en los actos humanos.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nom",
      ritual_name_value: "Rappel de souffle dans l’acte oublié",
      ritual_steps:
        "<ol>" +
        "<li>Elegir un gesto cotidiano: escribir, caminar o beber.</li>" +
        "<li>Repetirlo ralentizando el movimiento, en silencio.</li>" +
        "<li>En cada movimiento, pronunciar mentalmente: Yuyarīnâ.</li>" +
        "<li>Cerrar los ojos y visualizar el recuerdo más antiguo ligado a ese gesto.</li>" +
        "<li>Luego realizar el mismo gesto con una intención renovada.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Cuando una práctica se vuelve automática</li>" +
        "<li>Cuando la obra se debilita por repetición</li>" +
        "<li>Después de un período de fatiga poiética o pérdida de eje</li>" +
        "<li>En prácticas pedagógicas, terapéuticas o creativas que necesitan reinversión</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Katûpirsia</strong> — reintensifica cada <strong>Àpákan</strong> como memoria vibrante</li>" +
        "<li><strong>Takimarah</strong> — reorienta las modalidades hacia una activación consciente en la duración</li>" +
        "<li><strong>Tiqqunbahu</strong> — fragmenta los ciclos lineales para extraer los motivos olvidados</li>" +
        "<li><strong>Conscientisation dynamique</strong> — devuelve energía al acto en su vínculo con el sentido encarnado</li>" +
        "<li><strong>Posœnnomia</strong> — relanza prácticas colectivas y creativas desgastadas</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    }
  };

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_scope_value", "p_intro", "actions", "phrase",
      "table_rows", "entite_body", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = storeLang(normLang(lang) || "fr");

    syncDocumentLang(safeLang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }
    initAudioEverywhere(safeLang);

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK5YuyarinaInit) return;
    root.__poK5YuyarinaInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(lang);
  }

  window.PoK5YuyarinaTextsFR_EN_ES_20260313 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function(){
    try{
      __PO_PROTECT_RE__ = null;
      setLang(getLang());
    }catch(e){}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
